import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * AR Sync Status RPC Contract
 *
 * Provides an endpoint to query the last sync timestamp and result per entity type.
 * Used by the frontend to display when AR data was last refreshed.
 */

/**
 * Sync state item schema — represents one row from ar_sync_state
 */
export const ArSyncStateItemSchema = z.object({
  entityType: z.string(),
  lastSyncAt: z.coerce.date().nullable(),
  lastSyncCount: z.number().nullable(),
  lastSyncResult: z.record(z.string(), z.unknown()).nullable(),
});

/**
 * Get sync status response schema
 */
export const GetArSyncStatusResponseSchema = z.object({
  syncStates: z.array(ArSyncStateItemSchema),
});

/**
 * AR Sync Contracts
 */
export const arSyncContracts = {
  getStatus: oc.output(GetArSyncStatusResponseSchema).route({
    method: "GET",
    summary: "Get AR data sync status",
    description:
      "Returns the last sync time, record count, and result for each receivables entity type synced from the ERP, showing when AR data was last refreshed.",
  }),
} as const;

// Type exports
export type ArSyncStateItem = z.infer<typeof ArSyncStateItemSchema>;
export type GetArSyncStatusResponse = z.infer<
  typeof GetArSyncStatusResponseSchema
>;
